import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { parseElement } from "./parseElement.js";
import { replaceBindings } from "./replaceBindings.js";
export function parseLowLevelChildren(paths, state, app, options) {
  var rawChildren = paths.flatMap(function (p) {
    return parseElement(p, state, app, options);
  });

  // Remove leading and trailing nulls
  if (rawChildren.length > 0 && rawChildren[0] === null) {
    rawChildren = rawChildren.slice(1);
  }
  if (rawChildren.length > 0 && rawChildren[rawChildren.length - 1] === null) {
    rawChildren = rawChildren.slice(0, rawChildren.length - 1);
  }
  var onlyTextChildren = rawChildren.every(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === "text";
  });
  if (!onlyTextChildren) {
    var previousChild = null;
    var tempChildren = [];
    var _iterator = _createForOfIteratorHelper(rawChildren),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        if (child === null) {
          // Do nothing
        } else if (child.type === "text" || child.type === "expression") {
          var _previousChild, _previousChild2, _previousChild3;
          if (((_previousChild = previousChild) === null || _previousChild === void 0 ? void 0 : _previousChild.type) === "text" || ((_previousChild2 = previousChild) === null || _previousChild2 === void 0 ? void 0 : _previousChild2.type) === "expression") {
            previousChild = {
              type: "merged",
              children: [previousChild, child]
            };
            tempChildren.splice(tempChildren.length - 1, 1, previousChild);
            continue;
          } else if (((_previousChild3 = previousChild) === null || _previousChild3 === void 0 ? void 0 : _previousChild3.type) === "merged") {
            previousChild.children.push(child);
            continue;
          }
        }
        previousChild = child;
        tempChildren.push(child);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    rawChildren = tempChildren;
    onlyTextChildren = rawChildren.every(function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === "text" || (child === null || child === void 0 ? void 0 : child.type) === "merged" && child.children.every(function (c) {
        return c.type === "text";
      });
    });
  }
  if (onlyTextChildren) {
    var textContent = rawChildren.flatMap(function (child) {
      return child.type === "text" ? child.text : child.children.map(function (c) {
        return c.text;
      });
    }).join("").trim();
    return {
      textContent: textContent
    };
  }
  var onlyLooseTextChildren = rawChildren.every(function (child) {
    return !!child && child.type !== "component";
  });
  if (onlyLooseTextChildren) {
    var _textContent = constructMergeTexts(rawChildren.flatMap(function (child) {
      return child.type === "merged" ? child.children : child;
    }), state, app, options);
    return {
      textContent: _textContent
    };
  }
  var children = rawChildren.filter(function (child) {
    return !!child;
  }).map(function (child) {
    return child.type === "component" ? child.component : {
      name: "Plaintext",
      properties: {
        textContent: child.type === "text" ? child.text : child.type === "expression" ? replaceBindings(child.expression, state, app, _objectSpread(_objectSpread({}, options), {}, {
          modifier: "="
        })) : constructMergeTexts(child.children, state, app, options)
      }
    };
  });
  return {
    children: children
  };
}
function constructMergeTexts(elements, state, app, options) {
  state.usedHelpers.add("_helper_mergeTexts");
  return "<%= FN._helper_mergeTexts(".concat(elements.map(function (elem) {
    return elem.type === "text" ? JSON.stringify(elem) : "{type:\"expression\",value:(".concat(replaceBindings(elem.expression, state, app, options, true), ")}");
  }).join(", "), ") %>");
}
//# sourceMappingURL=parseLowLevelChildren.js.map